// ═══════════════════════════════════════════════════════════════════
//  modules/erp/MetierXpBar.js
//  MetierXpBar
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { nombre } from "./metiers";

// La barre ne calcule RIEN. Tout vient du back, qui tient la courbe
// (30 × 1,09^(n-1), maximum 100) et l'a confrontée à la base le
// 4 septembre. Une deuxième copie de la courbe ici, c'est deux endroits
// à corriger le jour où elle bouge, et un seul qu'on penserait à changer.
export function MetierXpBar({ niveau, progression, color, incoherent }) {
  const p = progression || { pourcent: 0, dans_le_niveau: 0, cout_du_niveau: 0, maxi: false };
  const teinte = incoherent ? THEME.amber : color;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: THEME.textMuted }}>
        <span style={{ color: THEME.text, fontWeight: 700 }}>Niv. {niveau}</span>
        {p.maxi
          ? <span style={{ color: THEME.gold, fontWeight: 700 }}>NIVEAU MAXIMUM</span>
          : <span>{nombre(p.dans_le_niveau, 1)} / {nombre(p.cout_du_niveau, 1)} XP</span>}
      </div>
      <div style={{ background: THEME.border, borderRadius: 4, height: 6, overflow: "hidden" }}>
        <div style={{
          background: teinte,
          width: `${Math.max(0, Math.min(100, p.pourcent))}%`,
          height: "100%", transition: "width 0.3s ease",
        }} />
      </div>
      {!p.maxi && (
        <div style={{ fontSize: 9, color: THEME.textDim, textAlign: "right" }}>
          reste {nombre(Math.max(0, p.cout_du_niveau - p.dans_le_niveau), 1)} XP
        </div>
      )}
    </div>
  );
}
